export class MethodNotImplementedError extends Error {
  constructor() {
    super(`method not implemented`)
  }
}
